import { BlocklistReasons } from '@strata/constants';
import { DialogWithForm } from '@strata/react-dialog';
import { SuggestSingleSelectFormik } from '@strata/react-selects';
import { SuccessToast } from '@strata/react-toast-message';
import { validationStrings } from '@strata/strata-ui-strings';
import { Formik } from 'formik';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { blocklistTreatment } from 'api/treatmentAPI';
import { handleError } from 'services/Error';

const Title = 'Blocklist Treatment';

export const BlocklistTreatmentDialog = ({
    isOpen,
    onClose,
    treatmentDetails = undefined,
    username,
    submitCallback,
}) => {
    const { treatmentId, payerId } = treatmentDetails ?? {};

    return (
        <Formik
            initialValues={{}}
            enableReinitialize
            validateOnMount
            validationSchema={Yup.object({
                reason: Yup.string().required(validationStrings.requiredField.errorMessage),
            })}
            onSubmit={async (values, { resetForm }) => {
                try {
                    await blocklistTreatment({
                        treatmentId,
                        payerId,
                        username,
                        reason: values.reason,
                    });

                    submitCallback();

                    SuccessToast({ message: 'Treatment blocklisted successfully.' });
                    resetForm();
                    onClose();
                } catch (err) {
                    handleError('Unable to blocklist treatment. Please try again.', err);
                }
            }}
        >
            {(formik) => (
                <DialogWithForm
                    dialogTitle={Title}
                    width={560}
                    isOpen={isOpen}
                    secondaryButtonLabel="Cancel"
                    onSecondaryButtonClick={() => {
                        onClose();
                        formik.resetForm();
                    }}
                    primaryButtonLabel={Title}
                    isPrimaryButtonDisabled={!formik.isValid || formik.isSubmitting}
                    dialogContent={
                        <>
                            <div className="margin__bottom--medium">
                                This action will prevent new referrals from being created.
                            </div>
                            <SuggestSingleSelectFormik
                                id="reason"
                                label="Reason"
                                required
                                values={BlocklistReasons}
                            />
                        </>
                    }
                />
            )}
        </Formik>
    );
};

BlocklistTreatmentDialog.Title = Title;

BlocklistTreatmentDialog.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    treatmentDetails: PropTypes.shape({
        treatmentId: PropTypes.string.isRequired,
    }),
    username: PropTypes.string.isRequired,
    submitCallback: PropTypes.func.isRequired,
};
